"use client";

import Script from "next/script";
import { markOsanoConsentExpected } from "../../core/mark-osano-consent-expected";

const OSANO_SEGMENT_WRAPPER_SRC = "https://cmp.osano.com/osano.segment.js";

type DataPrivacyManagementScriptsProps = {
  osanoConfigId?: string;
  osanoScriptSrc: string;
};

// Register when this client module evaluates so analytics init can see Osano
// is expected before the CMP scripts load.
markOsanoConsentExpected();

/**
 * Loads the Osano CMP script then the Segment wrapper via two ordered
 * `next/script` tags.
 *
 * `async={false}` opts the injected tags out of Next's force-async default so
 * `osano.js` executes before `osano.segment.js` (which provides
 * `window.withCMP`); `next/script` dedupes by `src`, so Suspense replays, React
 * remounts, and client navigations do not double-inject. Consent-gated Segment
 * init in `get-analytics-instance.ts` still defers `load()` until
 * `window.withCMP` and `window.Osano.cm` are ready.
 */
function DataPrivacyManagementScripts({
  osanoConfigId,
  osanoScriptSrc,
}: DataPrivacyManagementScriptsProps) {
  return (
    <>
      <Script
        async={false}
        data-config-id={osanoConfigId}
        data-osano-cmp="1"
        src={osanoScriptSrc}
        strategy="afterInteractive"
      />
      <Script
        async={false}
        data-osano-segment="1"
        src={OSANO_SEGMENT_WRAPPER_SRC}
        strategy="afterInteractive"
      />
    </>
  );
}

export { DataPrivacyManagementScripts };
